var app = (function() {
  $(function() {
    toggleSettings();
    profileToggle();
    widgetToggle();
    widgetClose();
    widgetFlip();
    tooltips();
  });

  var toggleSettings = function() {
    $(".config-link").click(function() {
      if ($(this).hasClass("open")) {
        $("#config").animate(
          {
            right: "-205px"
          },
          150
        );
        $(this)
          .removeClass("open")
          .addClass("closed");
      } else {
        $("#config").animate(
          {
            right: "0px"
          },
          150
        );
        $(this)
          .removeClass("closed")
          .addClass("open");
      }
    });
  };

  var navToggleRight = function() {
    $("#toggle-right").on("click", function() {
      $("#sidebar-right").toggleClass("sidebar-right-open");
      $("#toggle-right .fa").toggleClass("fa-indent fa-dedent");
    });
  };

  var customCheckbox = function() {
    $("input.icheck").iCheck({
      checkboxClass: "icheckbox_flat-grey",
      radioClass: "iradio_flat-grey"
    });
  };

  var profileToggle = function() {
    $("#toggle-profile").click(function() {
      $(".sidebar-profile").slideToggle();
    });
  };

  var widgetToggle = function() {
    $(".actions > .fa-chevron-down").click(function() {
      $(this)
        .parent()
        .parent()
        .next()
        .slideToggle("fast"),
        $(this).toggleClass("fa-chevron-down fa-chevron-up");
    });
  };

  var widgetClose = function() {
    $(".actions > .fa-times").click(function() {
      $(this)
        .parent()
        .parent()
        .parent()
        .fadeOut();
    });
  };

  var widgetFlip = function() {
    $(".actions > .fa-cog").click(function() {
      $(this)
        .closest(".flip-wrapper")
        .toggleClass("flipped");
    });
  };

  var dateRangePicker = function() {
    $(".reportdate").daterangepicker({
      format: "YYYY-MM-DD",
      startDate: "2014-01-01",
      endDate: "2014-06-30"
    });
  };

  //tooltips
  var tooltips = function() {
    $(".tooltip-wrapper").tooltip({
      selector: "[data-toggle=tooltip]",
      container: "body"
    });
  };

  //Sliders
  var sliders = function() {
    $(".slider-span").slider();
  };

  var nestedSortable = function() {
    var updateOutput = function(e) {
      var list = e.length ? e : $(e.target),
        output = list.data("output");
      if (window.JSON) {
        output.val(window.JSON.stringify(list.nestable("serialize"))); //, null, 2));
      } else {
        output.val("JSON browser support required for this demo.");
      }
    };

    // activate Nestable for list 1
    $("#nestable")
      .nestable({
        group: 1
      })
      .on("change", updateOutput);

    // activate Nestable for list 2
    $("#nestable2")
      .nestable({
        group: 1
      })
      .on("change", updateOutput);

    // output initial serialised data
    updateOutput($("#nestable").data("output", $("#nestable-output")));
    updateOutput($("#nestable2").data("output", $("#nestable2-output")));

    $("#nestable-menu").on("click", function(e) {
      var target = $(e.target),
        action = target.data("action");
      if (action === "expand-all") {
        $(".dd").nestable("expandAll");
      }
      if (action === "collapse-all") {
        $(".dd").nestable("collapseAll");
      }
    });
  };

  //return functions
  return {
    dateRangePicker: dateRangePicker,
    sliders: sliders,
    nestedSortable: nestedSortable,
    customCheckbox: customCheckbox
  };
})();
